/**
 * status-line.tsx — a line said to a screen reader and shown to no one: a
 * polite live region (role="status"), visually hidden, that says what it
 * holds as that changes. The game client's StatusLine, for the portal.
 *
 * A region that arrives with its words already in it is not reliably
 * announced, so the line mounts empty and holds back its first words until it
 * has been on the page long enough to be heard (useSettled, mirrored with the
 * client's), wherever it is mounted: in a window opened on demand, as a call
 * window's. From then on it says each change at once.
 *
 * A visible line that changes keeps its look and says itself through one of
 * these beside it — the call windows' status row: as a region itself, its
 * words would arrive with it, or it would draw empty first.
 *
 *   <StatusLine>{words}</StatusLine>
 */

import { useSettled } from './use-settled';
import utilities from '../styles/utilities.module.css';

interface StatusLineProps {
  /** What it says now, in words; nothing while there is nothing to say. */
  children?: string;
}

export function StatusLine({ children = '' }: StatusLineProps) {
  const settled = useSettled();
  return (
    <p role="status" className={utilities.visuallyHidden}>
      {settled ? children : ''}
    </p>
  );
}
